import { z } from "zod";

import { knownNextDevtoolsMcpToolMetadataRegistrySchema } from "./generated/local/next-devtools";
import { knownParallelSearchMcpToolMetadataRegistrySchema } from "./generated/remote/parallel-search";
import { knownBedrockMcpToolMetadataRegistrySchema } from "./replo/bedrockMcp";

export const knownMcpServerMetadataRegistries = {
  bedrock: knownBedrockMcpToolMetadataRegistrySchema.shape,
  "next-devtools": knownNextDevtoolsMcpToolMetadataRegistrySchema.shape,
  "parallel-search": knownParallelSearchMcpToolMetadataRegistrySchema.shape,
} as const;

const knownMcpToolMetadataRegistrySchema = z
  .object({
    ...knownMcpServerMetadataRegistries["bedrock"],
    ...knownMcpServerMetadataRegistries["next-devtools"],
    ...knownMcpServerMetadataRegistries["parallel-search"],
  })
  .describe("KnownMcpToolMetadataRegistry");
export const knownMcpToolMetadataRegistry =
  knownMcpToolMetadataRegistrySchema.shape;
